// Tiny wrapper for gtag so components can fire events safely even in dev.

export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch {
    /* noop */
  }
}

export function trackPageview(path) {
  try {
    const id = process.env.REACT_APP_GA_ID;
    if (!id) return;
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("config", id, { page_path: path });
    }
  } catch {
    /* noop */
  }
}
